import { LegacyInitializer } from './legacy.initializer';

export function legacyInitializerFactory(initializer: LegacyInitializer): () => Promise<any> {
  return () => initializer.wait();
}
